import useCustomer from 'src/app/customers/hooks/useCustomer';
import useProject from 'src/shared/hooks/useProject';
import useAppNavigation from 'src/shared/hooks/useAppNavigation';
import { AppViews, ProjectViews } from 'src/routes/routesConfig';

interface Breadcrumb {
    label: string;
    path?: string;
}
const useProjectBreadcrumb = (label: string): Breadcrumb[] => {
    const { currentProjectDetails } = useProject();
    const { currentCustomerId } = useCustomer();
    const { getPath } = useAppNavigation();

    const breadcrumbs: Breadcrumb[] = [];

    if (currentCustomerId) {
        breadcrumbs.push({
            label: 'My sites',
            path: getPath(AppViews.PROJECTS, { customerId: currentCustomerId }),
        });
    }

    if (currentProjectDetails?.projectId && currentCustomerId) {
        breadcrumbs.push({
            label: currentProjectDetails.projectName ?? '',
            path: getPath(ProjectViews.SITE_SUMMARY, {
                projectId: currentProjectDetails.projectId,
                customerId: currentCustomerId,
            }),
        });
    }

    if (label) {
        breadcrumbs.push({ label });
    }

    return breadcrumbs;
};

export default useProjectBreadcrumb;
